
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1977_3806)"}},[_c('path',{attrs:{"d":"M3.75 6v6c0 .412.338.75.75.75h9c.412 0 .75-.338.75-.75V6a.752.752 0 00-.75-.75h-9a.752.752 0 00-.75.75zm1.5 5.25V9h7.5v2.25h-7.5zm7.5-4.5v.75h-7.5v-.75h7.5z"}}),_c('path',{attrs:{"d":"M13.973 1.5H15c.412 0 .75-.337.75-.75A.752.752 0 0015 0h-3.75v3.75c0 .412.338.75.75.75s.75-.338.75-.75V2.505A7.455 7.455 0 0116.5 9c0 4.133-3.367 7.5-7.5 7.5S1.5 13.133 1.5 9 4.867 1.5 9 1.5c.412 0 .75-.337.75-.75A.752.752 0 009 0C4.035 0 0 4.035 0 9s4.035 9 9 9 9-4.035 9-9a8.95 8.95 0 00-4.027-7.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1977_3806"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    